import { render, staticRenderFns } from "./RealtimeDynamic.vue?vue&type=template&id=0b2ef6ae&scoped=true"
import script from "./RealtimeDynamic.vue?vue&type=script&lang=js"
export * from "./RealtimeDynamic.vue?vue&type=script&lang=js"
import style0 from "./RealtimeDynamic.vue?vue&type=style&index=0&id=0b2ef6ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2ef6ae",
  null
  
)

export default component.exports